<template>
    <section class="home-page__06">
        <img class="title" src="../../assets/images/home/page06/title.png" alt="title">

        <div class="content_wrap">
            <div class="video_wrap">
                <!-- bg -->
                <span class="video_wrap--hor"></span>
                <span class="video_wrap--ver"></span>
                <div class="video_content">
                    <img :src="charaImg" alt="">
                </div>

                <img src="../../assets/images/home/page06/right.png" alt="" class="video-right-btn" @click="toggle('right')">
                <img src="../../assets/images/home/page06/right.png" alt="" class="video-left-btn" @click="toggle('left')">
            </div>
            <div class="chara_wrap">
                <ul class="chara_content">
                    <li class="chara_box" v-for="(item, index) in charaList" :key="`chara_box-${index}`">
                        <div :class="['chara_imgbox', { 'imgbox_actived': charaIndex == item.index - 1 }]" @click="selectedChara(item.index - 1)">
                            <img :src="item.charabox" alt="">
                            <div :class="['chara_shadow', { 'shadow_actived': charaIndex == item.index - 1 }]"></div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        
        <scroll-bar></scroll-bar>
        <pre-login></pre-login>
        <firefly class="left-firefly" zindex="1" dir="left"></firefly>
        <firefly class="right-firefly" zindex="1" dir="right"></firefly>
    </section>
</template>

<script>
import scrollBar from "../../components/scroll-bar";
import preLogin from "../../components/pre-login";
import firefly from "../../components/firefly";

export default {
    name: "home-page06",

    components: {
        "scroll-bar": scrollBar,
        "pre-login": preLogin,
        firefly
    },
    data: () => ({
        charaIndex: 0,
        charaList: [
            {
                index: 7,
                charabox: require("../../assets/images/home/page06/07.png"),
                charaImgs: require("../../assets/images/home/page06/07_cg.png")
            },
            {
                index: 5,
                charabox: require("../../assets/images/home/page06/05.png"),
                charaImgs: require("../../assets/images/home/page06/05_cg.png")
            },
            {
                index: 6,
                charabox: require("../../assets/images/home/page06/06.png"),
                charaImgs: require("../../assets/images/home/page06/06_cg.png")
            },
            {
                index: 3,
                charabox: require("../../assets/images/home/page06/03.png"),
                charaImgs: require("../../assets/images/home/page06/03_cg.png")
            },
            {
                index: 4,
                charabox: require("../../assets/images/home/page06/04.png"),
                charaImgs: require("../../assets/images/home/page06/04_cg.png")
            },
            {
                index: 1,
                charabox: require("../../assets/images/home/page06/01.png"),
                charaImgs: require("../../assets/images/home/page06/01_cg.png")
            },
            {
                index: 2,
                charabox: require("../../assets/images/home/page06/02.png"),
                charaImgs: require("../../assets/images/home/page06/02_cg.png")
            }
        ]
    }),
    created() {

    },
    mounted() {

    },
    watch: {

    },
    computed: {
        charaImg() {
            for(let i = 0, len = this.charaList.length; i < len; i++) {
                if(this.charaList[i].index == this.charaIndex + 1) {
                    return this.charaList[i].charaImgs;
                }
            }
        }
    },
    methods: {
        selectedChara(index) {
            console.log(index)
            this.charaIndex = index;
        },
        toggle(dir) {
            if(dir === 'left') {
                if (this.charaIndex <= 0) {
                    this.charaIndex = this.charaList.length - 1;
                } else {
                    this.charaIndex -= 1;
                }
            } else if(dir === 'right') {
                this.charaIndex = (this.charaIndex + 1) % this.charaList.length;
            }
            console.log(dir, this.charaIndex)

        } 
    },
};
</script>

<style lang="scss" scoped>
.home-page__06 {
    background: url("../../assets/images/home/page06/bg.png") no-repeat
        center; 
    background-size: cover;
    overflow: hidden;
    position: relative;

    .title {
        position: absolute;
        z-index: 3;
        height: 100%;
        left: pxTorem(27px);
        opacity: 0.8;
    }

    .content_wrap {
        position: absolute;
        // top: 15%;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 3;
        
        .video_wrap {
            width: pxTorem(792px);
            height: pxTorem(443px);
            background: #000;
            position: relative;
            margin-bottom: pxTorem(30px);

            &--hor {
                &::before {
                    content: "";
                    position: absolute;
                    background: url("../../assets/images/home/video_border.png") no-repeat;
                    background-size: cover;
                    z-index: 3;

                    top: 0;
                    left: 0;
                    right: 0;
                    height: 5px;
                    background-position: 50% 0;
                }
                &::after {
                    content: "";
                    position: absolute;
                    background: url("../../assets/images/home/video_border.png") no-repeat;
                    background-size: cover;
                    z-index: 3;

                    bottom: 0;
                    left: 0;
                    right: 0;
                    height: 5px;
                    background-position: 50% 100%;
                }
            }

            &--ver {
                &::before {
                    content: "";
                    position: absolute;
                    background: url("../../assets/images/home/video_border.png") no-repeat;
                    background-size: cover;
                    z-index: 3;

                    top: 1px;
                    bottom: 1px;
                    left: 0;
                    width: 4px;
                    background-position: 0 0;
                }
                &::after {
                    content: "";
                    position: absolute;
                    background: url("../../assets/images/home/video_border.png") no-repeat;
                    background-size: cover;
                    z-index: 3;

                    top: 1px;
                    bottom: 1px;
                    right: 0;
                    width: 4px;
                    background-position: 100% 0;
                }
            }

            .video_content {
                width: 100%;
                height: 100%;
                position: relative;

                img {
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    z-index: 2;
                }
            }

            .video-right-btn {
                position: absolute;
                left: 103%;
                top: 50%;
                transform: translateY(-50%);
                cursor: pointer;
            }
            .video-left-btn {
                position: absolute;
                right: 103%;
                top: 50%;
                transform: translateY(-50%) scale(-1, 1);
                cursor: pointer;
            }
        }

        .chara_wrap {
            position: relative;
            overflow: hidden;
            margin-top: pxTorem(-160px);

            
            .chara_content {
                width: pxTorem(480px);
                height: pxTorem(480px);
                position: relative;
                left: 50%;
                transform: translateX(-50%) rotate(45deg);
                
                .chara_box {
                    display: block;
                    width: pxTorem(120px);
                    height: pxTorem(120px);
                    border: 1px solid #8c9394;
                    box-sizing: border-box;
                    float: left;
                    position: relative;

                    &:nth-of-type(1) {
                        margin-left: pxTorem(360px);
                        border-bottom: none;
                        border-top: none;
                        border-right: none;
                    }
                    &:nth-of-type(2) {
                        margin-left: pxTorem(240px);
                        border-bottom: none;
                        border-right: none;
                    }
                    &:nth-of-type(3) {
                        border-right: none;
                    }
                    &:nth-of-type(4) {
                        margin-left: pxTorem(120px);
                        border-bottom: none;
                        border-right: none;
                    }
                    &:nth-of-type(5) {
                        margin-right: pxTorem(120px);
                    }
                    &:nth-of-type(6) {
                        border-left: none;
                        border-bottom: none;
                    }
                    &:nth-of-type(7) {
                        border-left: none;
                        border-bottom: none;
                    }

                    .chara_imgbox {
                        position: relative;
                        width: 100%;
                        height: 100%;
                        cursor: pointer;
                        overflow: hidden;

                        &.imgbox_actived::after {
                            opacity: 0;
                        }

                        &::after {
                            content: "";
                            display: block;
                            width: 100%;
                            height: 100%;
                            position: absolute;
                            top: 0;
                            left: 0;
                            background: rgba(0, 0, 0, .4);
                            transition: all .3s;
                        }

                        &:hover::after {
                            opacity: 0;
                        }
                        
                        img {
                            display: block;
                            width: 126%;
                            position: absolute;
                            left: 50%;
                            top: 50%;
                            transform: translate(-50%, -50%) rotate(-45deg);
                        }

                        .chara_shadow {
                            width: 90%;
                            height: 90%;
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            transition: all .3s;
                            z-index: -1;

                            &.shadow_actived {
                                box-shadow: 0 0 4px 2px #00e0b3;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
